export type SocialPost = {
  id: number;
  content: string;
  hashtags: string[];
  mediaIds: string[];
  created_date: string;
  updated_date: string;
  publish_at: string | null;
  is_live: boolean;
  platform: string[];
};

export enum SocialPostStage {
  Failed = 'Failed',
  Pending = 'Pending',
  Published = 'Published',
  Scheduled = 'Scheduled',
  Draft = 'Draft',
}

export enum SocialPlatform {
  Facebook = 'Facebook',
  Instagram = 'Instagram',
}

export enum FacebookPostSizeMode {
  Landscape = 'Landscape',
  Square = 'Square',
}

export enum InstagramPostSizeMode {
  Square = 'Square',
}
